// extracted by mini-css-extract-plugin
export default {"wholeTableReservationWrapper":"yqMaG1","mobile":"jFGh10","occupied":"kqYjeE","selected":"IsrtiV"};